import VueRouter from "vue-router"
import Home from '../views/home'
import Game from '../views/game'
import Scene from '../views/game/scene'
import MyBag from '../views/game/mybag'
import MyShare from '../views/share'
export default new VueRouter({
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            component: Home
        },
        {
            path: '/game',
            component: Game,
            redirect: '/game/scene',
            children: [
                {
                    path: 'scene',
                    component: Scene
                },
                {
                    path: 'mybag',
                    component: MyBag
                }
            ]
        },
        {
            path: '/myshare',
            component: MyShare
        }
    ]
})